/**
 * Created by thk on 4/16/2021.
 */
'use strict';
angular.module('betosyswebapp')
  .controller('CommandController', function ($scope, $uibModalInstance, $filter, AuthenticationService, widgetSettingsCreatorService, commonTrackService, toastService, $translate) {
    var commandType = 'config';
    $scope.deviceCommand = {
      deviceID: '',
      commandID: ''
    };
    $scope.userName = $scope.userName = AuthenticationService.GetLoginUserName();
    $scope.commandVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'deviceID'
    });
    $scope.commandCommandSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });
    var fleetServerDetails;
    var loadDevices = function () {
      return commonTrackService.getDeviceComboList().then(function (vehicleList) {
        $scope.commandVehicleSettings.source = vehicleList;
        var LstLocationSectedData = commonTrackService.getsetLastLocatioWidgetData();
        if (LstLocationSectedData && LstLocationSectedData.selectedRow && LstLocationSectedData.selectedRow.deviceid) {
            $scope.deviceCommand.deviceID = LstLocationSectedData.selectedRow.deviceid;
        }
      }).then(function () {
        commonTrackService.getFleetServerDetails().then(function (fleetDetails) {
          fleetServerDetails = fleetDetails;
        });	    
      }).finally(function () {
        $scope.deviceLoadingFinished = true;
        loadCommands();
      });
    };

    var loadCommands = function () {
      $scope.commandCommandSettings.source = [];
      if ($scope.deviceCommand.deviceID) {
          commonTrackService.getVehicleGridCommandList($scope.deviceCommand.deviceID).then(function (commandList) {
            $scope.commandCommandSettings.source = commandList;   
          }).finally(function () {
            $scope.commandLoadingFinished = true;
          });
      }
    };

    loadDevices();
    $scope.ok = function () {
      $uibModalInstance.close($scope.selected.item);
    };

    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };
    $scope.send = function () {
      if ($scope.deviceCommand.commandID) {
        if ($scope.deviceCommand.deviceID) {

        commonTrackService.sendCommand($scope.deviceCommand.deviceID, commandType, $scope.deviceCommand.commandID).then(function () {
          toastService.showSuccessToast($translate.instant('deviceCommands.sendSuccess'));
        }, function (response) {
          var _messsage = response.data && response.data.errors && response.data.errors[0].code ? $translate.instant('errorCodes.restAPI.' + response.data.errors[0].code + '.message') : response.data.message;
          var errorAlert = {type: 'F', message: _messsage};
          toastService.showErrorToast(errorAlert);
        }).finally(function () {
        });
        }
      }
    };
    $scope.commandCommandComboChange = function (event) {
      if (event.args && event.args.item && event.args.item.value) {
        loadCommands();
      }
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/navbar/commandController.js